import script from "./ListaDeAgendamentosRepository.vue?vue&type=script&lang=js"
export * from "./ListaDeAgendamentosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__